/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { PermissionsService } from './permission.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[permission]',
})
export class PermissionDirective implements AfterViewInit {
  @Input() permission: string;

  constructor(private el: ElementRef, private permissions: PermissionsService) {}

  ngAfterViewInit() {
    this.permissions.has(this.permission) ? this.toggleEle(false) : this.toggleEle(true);
  }

  toggleEle(bool: boolean) {
    this.el.nativeElement.hidden = bool;
  }
}
